import parentApi from './axios/studentAxios';
import portalApi from './axios/portalAxios';

export const getGradesRequest = () => portalApi.get('/grades');

export const getEducationLevelsRequest = () => portalApi.get('/education-levels');

export const getGradeTypesRequest = (gradeId) =>
  portalApi.get(gradeId ? `/grade-types/${gradeId}` : '/grade-types');

export const getGradeTypeSubjectsRequest = (gradeTypeGradeId) =>
  portalApi.get(`/grade-type-grade-subjects/${gradeTypeGradeId}`);

export const getEduLevelSubjectsRequest = (educationLevelCode) =>
  portalApi.get(`/edu-level-subjects/${encodeURIComponent(educationLevelCode)}`);

export const getScheduleMediumsRequest = () => portalApi.get('/mediums');

export const getScheduleClassTypesRequest = () => portalApi.get('/class-types');

export const getTeacherProfileByCodeRequest = (teacherCode) =>
  parentApi.get(`/teacher-profiles/${encodeURIComponent(teacherCode)}`);

export const createStudentClassRequest = (studentId, data) =>
  parentApi.post(`/students/${studentId}/classes`, data);
